"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PersonalProductsListDetail = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _AddProductsToBasketResultDialog = require("../AddProductsToBasketResultDialog");
var _Products = require("../Products");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PersonalProductsListDetail = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { palette } = (0, _mui.useTheme)();
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const { breadcrumbs, firstName, lastName, products } = (0, _contexts.useDetailContext)();
    const { addingToBasket, onClose, countOfSuccessfullyAdded, onAddProductsToBasket, open } = (0, _hooks.useProductAddingToBag)();
    const shouldShowAddProductsToBasketButton = products.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.PERSONAL_PRODUCTS_LIST_DETAIL),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.TopBanner, {
                backgroundColor: palette.primary.main,
                breadcrumbs: breadcrumbs,
                textColor: palette.text.primary,
                title: formatMessage('personalProductsListDetailTitle', {
                    FirstName: firstName,
                    LastName: lastName
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Products.Products, {}),
                    shouldShowAddProductsToBasketButton ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.AddProductsToBasketButton, {
                        variant: "contained",
                        color: "primary",
                        loading: addingToBasket,
                        startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.AddToBag, {}),
                        onClick: onAddProductsToBasket,
                        children: translations.addProductsToBag
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddProductsToBasketResultDialog.AddProductsToBasketResultDialog, {
                countOfSuccessfullyAdded: countOfSuccessfullyAdded,
                open: open,
                onClose: onClose
            })
        ]
    });
};
exports.PersonalProductsListDetail = PersonalProductsListDetail;
